import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import type { ReactNode } from 'react';
import React from 'react';

import useResolver from '@swf/core/hooks/useResolver';
import { translatedLink } from '@swf/core/utils';

import {
  TXTWCL_If_you_continue_to_encounter_p_ELL,
  TXTWCL_Please_refresh_your_browser_an_ELL
} from './PowMessage.messages.json';

export interface Props {
  className?: string;
  title?: ReactNode;
}

const PowMessage: React.FC<Props> = ({ className, title }) => {
  const failedPow = useResolver(ResolverTag.FailedPow);

  const body = (
    <>
      {title} <Translation {...TXTWCL_Please_refresh_your_browser_an_ELL} />{' '}
      <Translation
        {...TXTWCL_If_you_continue_to_encounter_p_ELL}
        values={{
          a: translatedLink({ href: failedPow })
        }}
      />
    </>
  );

  return className ? <p className={className}>{body}</p> : body;
};

export default PowMessage;
